module.exports = "/_next/static/images/cafe_haleiwa_pancake-60fba05d6f4571df717071e4eec5c940.jpg";